export default __webpack_public_path__ + "static/media/151-title.d83ad056.png";